export default "__VITE_ASSET__DQ4Ps7WT__"